import { createGlobalStyle } from 'antd-style';

import leagueGothicOtf from '../resources/fonts/LeagueGothic-Regular.otf';
import leagueGothicWoff from '../resources/fonts/LeagueGothic-Regular.woff';
import leagueGothicWoff2 from '../resources/fonts/LeagueGothic-Regular.woff2';

const FontStyles = createGlobalStyle({
  '@font-face': {
    fontFamily: 'League Gothic',
    src: `url('${leagueGothicWoff2}'), url('${leagueGothicWoff}'), url('${leagueGothicOtf}')`,
    fontWeight: 'normal',
    fontStyle: 'normal',
  },
});

export default FontStyles;
